import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Slider from 'react-slick';
import Avatar from '@components/@core/Avatar';
import Icon from '@components/@core/Icon';
import { PulseLoader } from 'react-spinners';
import Rating from '@components/@core/Rating';
import CommunityActions from '~/actions/community';

const FeaturedDepartments = ({ onProductDetail, loading = true }) => {
    const dispatch = useDispatch();

    const categories = useSelector((state) => state.community.featuredCategories);
    const products = useSelector((state) => state.community.featuredProducts);
    const subStatus = useSelector((state) => state.community.subStatus);
    const [current, setCurrent] = useState(0);

    useEffect(() => {
        dispatch(CommunityActions.getfeaturedcategoriesRequest({}, loading));
    }, []);

    useEffect(() => {
        categories.forEach((item) => {
            dispatch(CommunityActions.getcategorysponsoredproductsRequest(item.id, loading));
        });
    }, [categories]);

    let slider;
    const handleClick = (e) => {
        setCurrent(e);
        slider.slickGoTo(e);
    };

    const settings = {
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2600,
        pauseOnHover: false,
        beforeChange: (before, next) => setCurrent(next),
    };

    return (
        <div className="featured-departments overflow-hidden">
            <div className="d-flex px-3">
                <p className="dsl-b18 bold me-auto head">Featured {categories[current]?.name}</p>
                {[...Array(categories.length).keys()].map((item) => (
                    <Icon key={`ic${item}`} name="fas fa-circle ms-1 mt-1" color={current === item ? '#6899d7' : '#e5eef8'} size={14} onClick={() => handleClick(item)} />
                ))}
            </div>
            {subStatus.includes('pending-featured') ? (
                <div className="space">
                    <PulseLoader className={18} loading color={'#376caf'} size={18} />
                </div>
            ) : (
                <div className="featured-departments-list">
                    <Slider ref={(e) => (slider = e)} {...settings}>
                        {categories?.map((category, idx) => (
                            <div key={idx}>
                                {products[category?.id]?.length > 0 ? (
                                    products[category?.id]?.map((item, index) => (
                                        <div className="d-h-center mb-2 cursor-pointer product-list" key={index} onClick={() => onProductDetail(item, category?.id)}>
                                            <div className="d-flex-2">
                                                <Avatar
                                                    url={item?.logo}
                                                    name={item?.name}
                                                    size="small"
                                                    isSponsored={item?.data?.sponsored_level === 'gold' || item?.data?.sponsored_level === 'silver'}
                                                />
                                            </div>
                                            <div className="d-flex-4 px-2">
                                                <p className="dsl-b14 text-400 truncate-two mb-1">{item?.name}</p>
                                                <p className="dsl-b14 mb-0">Rating: {item?.stats?.rating_count}</p>
                                            </div>
                                            <div className="d-flex-3">
                                                <Rating score={item?.stats?.rating_avg} />
                                                <span className="dsl-b14">{Math.round(item?.stats?.rating_recommended_avg)}% recommended</span>
                                            </div>
                                        </div>
                                    ))
                                ) : (
                                    <p className="dsl-m14 text-center mt-3">No Top Rated {categories[idx]?.name || 'Products'} available</p>
                                )}
                            </div>
                        ))}
                    </Slider>
                </div>
            )}
        </div>
    );
};

export default FeaturedDepartments;
